<template>
  <div
    :class="$style.recommendedPolicyCard"
  >
    <p :class="$style.title">
      {{ title }}
    </p>
    <p :class="$style.description">
      {{ description }}
    </p>
    <p :class="$style.availability">
      <span
        :class="$style.configureForText"
      >
        Configure for:
      </span>
      <a
        v-for="system in availability"
        :key="system.title"
        :class="$style.systemLink"
        :href="system.href"
      >
        {{ system.title }}
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'RecommendedPolicyCard',

  props: {
    availability: {
      type: Array,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style module>

@value (jcInformational50) from '~css/brand-colors.css';

.recommendedPolicyCard {
  background-color: jcInformational50;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  height: 180px;
  justify-content: space-between;
  min-width: 210px;
  padding: 20px;
  position: relative;
}

.title {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
}

.description {
  flex-basis: 50%;
  font-size: 12px;
  font-weight: 300;
  line-height: 1.1;
}

.availability {
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

.configureForText {
  display: inline-block;
}

.recommendedPolicyCard .systemLink {
  display: inline-block;
  margin-right: 5px;
}
</style>
